import { render, staticRenderFns } from "./PzBackButton.vue?vue&type=template&id=42822eb1&"
import script from "./PzBackButton.vue?vue&type=script&lang=js&"
export * from "./PzBackButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\clientesapp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42822eb1')) {
      api.createRecord('42822eb1', component.options)
    } else {
      api.reload('42822eb1', component.options)
    }
    module.hot.accept("./PzBackButton.vue?vue&type=template&id=42822eb1&", function () {
      api.rerender('42822eb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/commons/forms/Buttons/PzBackButton.vue"
export default component.exports